/** @format */
import { post, download } from '@root/utils/httpWrap';

function transformParam(p: any) {
  return {
    ...p,
    userId: ''
  };
}

/**
 * 预约车辆管理
 */
export const queryAppointmentRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/appointmentOwner/list', transformParam(params));
};

/**
 * 预约车添加
 */
export const addAppointmentRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/appointmentOwner/addOrEdit', params);
};
/**
 * 预约车详情
 */
export const infoAppointmentRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/appointmentOwner/info', params);
};
